import React, {Component} from 'react';
import {Container, Card, CardHeader, CardBody, CardFooter, Breadcrumb, BreadcrumbItem} from 'reactstrap';
import axios from 'axios';
import Cookies from 'universal-cookie'


const cookies = new Cookies()

const qs = require('qs');
const prebase = window.location.protocol + '//' + window.location.host;
const base = (prebase.indexOf('3000') > -1) ? prebase.replace('3000', '8080') : prebase;

export default class ScreeningList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pid: props.match.params.pid,
            screenings: [],
        };
        this.loadPatient();
    }

    loadPatient() {
        let authToken = cookies.get('auth_token')
        axios({
            method: 'get',
            url: `${base}/api/patients/patient/${this.state.pid}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${authToken}`
            },
            withCredentials: true,
        }).then(response => {
            this.setState({
                patient: response.data[0],
            }, this.loadScreening);
        }).catch(error => {
            console.log(error);
        })
    }
    
    loadScreening() {
        let authToken = cookies.get('auth_token')
        axios({
            method: 'get',
            url: `${base}/api/patients/screening/${this.state.pid}/list/`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${authToken}`
            },
            withCredentials: true,
        }).then(response => {
            this.setState({
                screenings: response.data,
            })
        }).catch(error => {
            console.log(error);
        })
    }

    render() {
        let patient = this.state.patient ? this.state.patient.fields : {};
        return (
            <Container>
                <Card>
                    <CardHeader>
                        <h2 className="float-left">Patient Health Questionnaire 9 Item</h2>
                        <a className="mui-btn mui-btn--raised float-right" href={"/admin/screening?" + qs.stringify({pid: this.state.pid, then: `/admin/patients/${this.state.pid}/screening/list`})}>Update Screening</a>
                    </CardHeader>
                    <CardBody>
                        {this.state.screenings.map((screening) => (
                            <a key={screening.pk} href={`/admin/patients/${this.state.pid}/screening/${screening.pk}`}>
                                <Card key={screening.pk}> 
                                    <CardBody>
                                    <p className="h4 float-left">{patient.LastName + ', ' + patient.FirstName}</p>
                                    <p className="h5 float-right">{screening.fields.updated}</p>
                                    </CardBody>
                                </Card>
                            </a>
                        ))}
                    </CardBody>
                    <CardFooter>
                    </CardFooter>
                </Card>
            </Container>
        )
    }
}
